module.exports = __webpack_public_path__ + "images/shooper.3df9c356.svg";